import "soundmanager2";

import lwAPI from "@/common/api.service";

import store from "@/store";

// function randomChoice(arr) {
//   return arr[Math.floor(Math.random() * arr.length)];
// }

let VOICES = {
  en: { languageCode: "en-US", name: "en-US-Wavenet-C" },
  de: { languageCode: "de-DE", name: "de-DE-Wavenet-B" },
  ru: { languageCode: "ru-RU", name: "ru-RU-Wavenet-B" },
  fr: { languageCode: "fr-FR", name: "fr-FR-Wavenet-A" },
  es: { languageCode: "es-ES", name: "es-ES-Standard-A" },
  it: { languageCode: "it-IT", name: "it-IT-Wavenet-D" },
  "zh-CN": { languageCode: "cmn-CN", name: "cmn-CN-Wavenet-A" },
  jp: { languageCode: "ja-JP", name: "ja-JP-Wavenet-A" },
};

function tts(text, languageCode, voiceName, speakingRate = 1.0) {
  const baseUrl = "https://liteword.com";
  const url = `${baseUrl}/tts?text=${encodeURIComponent(
    text
  )}&lc=${languageCode}&vn=${voiceName}&sr=${speakingRate}`;
  return url;
}

function itemTemplateForward(player, data) {
  let termTtsSlow = tts(
    data.term,
    VOICES[data.term_language].languageCode,
    VOICES[data.term_language].name,
    0.6
  );
  let termTtsNormal = tts(
    data.term,
    VOICES[data.term_language].languageCode,
    VOICES[data.term_language].name,
    1.0
  );

  let dataWithText = makeDataWithText(data, data.term);

  player.addTrack("t" + data.id, termTtsSlow, dataWithText);
  player.addTrack("t" + data.id, termTtsNormal, dataWithText); // add term twice instead of meaning

  if (data.meaning) {
    let meaningTts = tts(
      data.meaning,
      VOICES[data.meaning_language].languageCode,
      VOICES[data.meaning_language].name
    );

    player.addTrack(
      "m" + data.id,
      meaningTts,
      makeDataWithText(data, data.meaning)
    );
  }

  for (let example of data.examples) {
    let exampleTts = tts(
      example.content,
      VOICES[data.term_language].languageCode,
      VOICES[data.term_language].name
    );
    player.addTrack(
      "ec" + example.id,
      exampleTts,
      makeDataWithText(data, example.content)
    );

    if (example.description) {
      let descriptionTts = tts(
        example.description,
        VOICES[data.meaning_language].languageCode,
        VOICES[data.meaning_language].name
      );

      player.addTrack(
        "ed" + example.id,
        descriptionTts,
        makeDataWithText(data, example.description)
      );

      // And repeat
      player.addTrack(
        "ec" + example.id,
        exampleTts,
        makeDataWithText(data, example.content)
      );
    }
  }
}

function itemTemplateWordIntro(player, data) {
  const opening = "Do you know how to say?";
  let openingTts = tts(opening, VOICES["en"].languageCode, VOICES["en"].name);

  player.addTrack(opening, openingTts, { ...data, pause: 300 });

  let meaningTts = tts(
    data.meaning,
    VOICES[data.meaning_language].languageCode,
    VOICES[data.meaning_language].name
  );

  player.addTrack("m" + data.id, meaningTts, {
    ...data,
    text: data.meaning,
    pause: 3 * 1000,
  });

  let termTts = tts(
    data.term,
    VOICES[data.term_language].languageCode,
    VOICES[data.term_language].name,
    0.6
  );

  let dataWithText = makeDataWithText(data, data.term);

  player.addTrack("t" + data.id, termTts, dataWithText);
  player.addTrack(
    "t" + data.id,
    termTts,
    data.examples.length ? dataWithText : { ...dataWithText, pause: 3 * 1000 }
  );

  for (let example of data.examples) {
    let exampleTts = tts(
      example.content,
      VOICES[data.term_language].languageCode,
      VOICES[data.term_language].name
    );

    player.addTrack(
      "ec" + example.id,
      exampleTts,
      makeDataWithText(data, example.content)
    );

    if (example.description) {
      let descriptionTts = tts(
        example.description,
        VOICES[data.meaning_language].languageCode,
        VOICES[data.meaning_language].name
      );

      player.addTrack(
        "ed" + example.id,
        descriptionTts,
        makeDataWithText(data, example.description)
      );

      // And repeat
      player.addTrack(
        "ec" + example.id,
        exampleTts,
        makeDataWithText(data, example.content)
      );
    }
  }
}

function itemTemplateBackward(player, data) {
  let meaningTts = tts(
    data.meaning,
    VOICES[data.meaning_language].languageCode,
    VOICES[data.meaning_language].name
  );

  player.addTrack("m" + data.id, meaningTts, {
    ...data,
    text: data.meaning,
    pause: 3 * 1000,
  });

  let termTts = tts(
    data.term,
    VOICES[data.term_language].languageCode,
    VOICES[data.term_language].name,
    0.6
  );

  let dataWithText = makeDataWithText(data, data.term);

  player.addTrack("t" + data.id, termTts, dataWithText);
  player.addTrack(
    "t" + data.id,
    termTts,
    data.examples.length ? dataWithText : { ...dataWithText, pause: 3 * 1000 }
  );

  for (let example of data.examples) {
    let exampleTts = tts(
      example.content,
      VOICES[data.term_language].languageCode,
      VOICES[data.term_language].name
    );

    player.addTrack(
      "ec" + example.id,
      exampleTts,
      makeDataWithText(data, example.content)
    );

    if (example.description) {
      let descriptionTts = tts(
        example.description,
        VOICES[data.meaning_language].languageCode,
        VOICES[data.meaning_language].name
      );
      player.addTrack(
        "ed" + example.id,
        descriptionTts,
        makeDataWithText(data, example.description)
      );

      // And repeat
      player.addTrack(
        "ec" + example.id,
        exampleTts,
        makeDataWithText(data, example.content)
      );
    }
  }
}

function makeDataWithText(data, text) {
  return { ...data, text };
}

function updateItemRecall(studyItemId, correct) {
  return lwAPI.post(`/studyitems/updaterecall/`, {
    id: studyItemId,
    value: correct,
  });
}

function ignoreItem(studyItemId) {
  return lwAPI.post("/studyitems/ignore/", {
    id: studyItemId,
  });
}

class ItemQueue {
  constructor(items, loadMore) {
    this.queue = items;
    this.loadMore = loadMore;
  }

  shift() {
    return new Promise((resolve) => {
      const next = this.queue.shift();
      if (next) {
        resolve(next);
        this.loadMore().then((result) => this.queue.push(result));
      } else {
        this.loadMore().then((result) => resolve(result));
      }
    });
  }
}

class Player {
  constructor(itemQueue) {
    this.soundManager = window.soundManager;

    this.soundManager.setup({
      url: "/path/to/swf-files/",
      onready: function() {},
      ontimeout: function() {},
    });

    this.queue = [];
    this.currentTrack = null;
    this.currentSound = null;
    this.isPlaying = false;
    this.defaultPause = 1.5 * 1000;
    this.itemQueue = itemQueue;

    // Fix Safari SyntaxError: Unexpected token
    this._finishHanlder = () => {
      this._log(`Finished. Queue length: ${this.queue.length}`);
      this.queue.shift();

      if (this.queue.length == 0) {
        updateItemRecall(this.getCurrentTrackMetadata().id, false);
      }

      let pause = this.getCurrentTrackMetadata().pause || this.defaultPause;

      this._log(`Pausing for ${pause}`);
      this._pause(pause).then(() => {
        this._log("Resumed");
        this._playFirstItem();
      });
    };
  }

  play() {
    this.isPlaying = true;
    this._playFirstItem();
  }

  stop() {
    // Stop the loop
    this.isPlaying = false;

    // Stop the player if playing
    if (this.currentSound) {
      this.soundManager.stop(this.currentSound.id);
    }
  }

  setPosition(offset) {
    this.soundManager.setPosition(this.currentSound.id, offset);
  }

  addTrack(id, url, metadata) {
    console.log(id, url);
    this.queue.push({ id: id, url: url, metadata: metadata });
  }

  getCurrentTrackMetadata() {
    return this.currentTrack.metadata;
  }

  skipToNext() {
    this.isPlaying = false;
    this.soundManager.stop(this.currentSound.id);
    this.queue = [];
    this.isPlaying = true;
    this._playFirstItem();
  }

  _log(message) {
    console.log("Player:", message);
  }

  _pause(milliseconds) {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  }

  _getNextTrack() {
    return new Promise((resolve, reject) => {
      if (this.queue.length == 0) {
        this.itemQueue.shift().then((nextItem) => {
          if (nextItem.data == "NO_ITEMS") {
            return reject(new Error("NO_ITEMS"));
          }
          nextItem.template(this, nextItem.data);
          resolve(this.queue[0]);
        });
      } else {
        resolve(this.queue[0]);
      }
    });
  }

  _playFirstItem() {
    if (this.isPlaying) {
      this._getNextTrack().then(
        (track) => {
          this.currentSound = this.soundManager.createSound({
            id: track.id,
            url: track.url,
            autoLoad: true,
            onfinish: this._finishHanlder,
          });
          this.currentTrack = track;

          // XXX Code smell
          store.dispatch("updatePlayingInfo", {
            title: track.metadata.text,
          });

          this.currentSound.play();
        },
        (error) => {
          if (error.message == "NO_ITEMS") {
            this.isPlaying = false;

            // XXX Code smell
            store.dispatch("stop");
            store.dispatch("showNoMoreItemsDialog");
            store.dispatch("hidePlayer");
          } else {
            throw error;
          }
        }
      );
    }
  }
}

const PlayerService = {
  init() {
    const itemQueue = new ItemQueue([], this.getNextItem.bind(this));
    this.player = new Player(itemQueue);
    this.currentStudyList = null;
  },

  setCurrentStudyList(id) {
    // Reset player and set the new study list
    this.currentStudyList = id;
    // Refactor this.player.skipToNext();
    if (this.player.currentSound) {
      this.player.stop();
    }
    this.player.queue = [];
  },

  getNextItem() {
    const studyListId = this.currentStudyList;

    const urlParams = new URLSearchParams(window.location.search);
    const scheduleMethod = urlParams.has("s") ? urlParams.get("s") : "p";

    return lwAPI
      .get("/studylists/" + studyListId + "/next/?s=" + scheduleMethod)
      .then((response) => {
        const data = response.data;
        if (data === "") {
          return { data: "NO_ITEMS" };
        } else {
          //itemTemplateWordIntro
          const template =
            data["p"] == 1
              ? data["meaning"]
                ? itemTemplateWordIntro
                : itemTemplateForward
              : data["meaning"]
              ? itemTemplateBackward
              : itemTemplateForward;

          return { data: data, template: template };
        }
      });
  },

  play() {
    this.player.play();
  },

  stop() {
    this.player.stop();
  },

  previous() {
    // Restart playing
    // later also skip to previous (double click)
    this.player.setPosition(0);
  },

  next() {
    const metadata = this.player.getCurrentTrackMetadata();
    updateItemRecall(metadata.id, true).then(() => {
      this.player.skipToNext();
    });
  },

  ignore: function() {
    const metadata = this.player.getCurrentTrackMetadata();
    ignoreItem(metadata.id).then(() => {
      this.player.skipToNext();
    });
  },

  isPlaying() {
    return this.player.isPlaying;
  },
};

export default PlayerService;
